import IconButton from '@mui/material/IconButton';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';



function HelpButton({onClick}) {
    
    return (
       <IconButton aria-label="Help Button" className="" size="small" 
          onClick={(e) => {onClick(); e.stopPropagation(); e.preventDefault();}}>
          <FuseSvgIcon className="text-20" color="action">
            heroicons-solid:question-mark-circle
          </FuseSvgIcon>
        </IconButton>  
    );
    
    
}

export default HelpButton;